var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-section" }, [
    _c("section", { staticClass: "el-section" }, [
      _c("div", { staticClass: "el-chunk" }, [
        _c("h2", { staticClass: "emd-text _size_page" }, [
          _vm._v(_vm._s(_vm.$t("welcome"))),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "el-section" }, [
      _c(
        "div",
        {
          staticClass: "emd-spotlight-list",
          class: { "_has-selected": _vm.selectedPaymentType },
        },
        [
          _c(
            "div",
            { staticClass: "eu-flex eu-justify_center" },
            _vm._l(_vm.visiblePaymentTypeItems, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "eu-flex-item eu-basis_12 eu-basis_6_md eu-mb_3 eu-no-margin_md",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "emd-spotlight-list__item emd-container _type_card _content_stretch eu-display_flex _actionable eu-pa_4 _selected",
                      class: {
                        "_active _selected":
                          _vm.selectedPaymentType === item.title,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectPaymentType(item.title)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "emd-container__header" }, [
                        _c(
                          "span",
                          {
                            staticClass: "emd-text",
                            class: {
                              _color_tertiary:
                                _vm.selectedPaymentType === item.title,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "emd-text _size_page",
                              class: ["uil", item.icon],
                            }),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "emd-container__content" }, [
                        _c(
                          "p",
                          { staticClass: "emd-text _type_caption eu-pb_1" },
                          [_vm._v(_vm._s(_vm.$t(item.title + ".label")))]
                        ),
                        _c("p", { staticClass: "emd-text" }, [
                          _vm._v(_vm._s(_vm.$t(item.title + ".description"))),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "emd-highlight-tag _bottom",
                            class: {
                              "_active _color_tertiary":
                                _vm.selectedPaymentType === item.title,
                            },
                          },
                          [_vm._m(0, true)]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "eu-position_relative" }, [
      _c("i", { staticClass: "uil uil-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }